/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './layout-include-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-layout-include-list-page',
  template
})
export class LayoutIncludeListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.layout-includes.layout-include';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'reference'},
    {param: 'description'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
